import { render, staticRenderFns } from "./StoryList.vue?vue&type=template&id=06962a5d&scoped=true"
import script from "./StoryList.vue?vue&type=script&lang=js"
export * from "./StoryList.vue?vue&type=script&lang=js"
import style0 from "./StoryList.vue?vue&type=style&index=0&id=06962a5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06962a5d",
  null
  
)

export default component.exports